import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

import type { UnpaidBranchData } from '../../types/report';

interface UnpaidBarChartProps {
  data: UnpaidBranchData[];
}

const formatCurrency = (value: number) => {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}만`;
  }
  return value.toLocaleString();
};

export const UnpaidBarChart = ({ data }: UnpaidBarChartProps) => {
  const chartData = data.map((item) => ({
    name: item.branchName,
    미납금액: item.unpaidAmount,
    건당미납액: item.unpaidPerContract,
  }));

  return (
    <div className="h-80">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} layout="vertical" margin={{ top: 20, right: 30, left: 100, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis type="number" tickFormatter={formatCurrency} tick={{ fontSize: 11 }} />
          <YAxis type="category" dataKey="name" tick={{ fontSize: 11 }} width={90} />
          <Tooltip
            formatter={(value, name) => [
              `${Number(value).toLocaleString()}원`,
              name === '미납금액' ? '미납금액' : '건당 미납액',
            ]}
          />
          <Bar dataKey="미납금액" radius={[0, 4, 4, 0]}>
            {chartData.map((_, index) => (
              <Cell key={`cell-${index}`} fill={index < 3 ? '#ef4444' : index < 6 ? '#f97316' : '#fbbf24'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
